import { inject, Injectable } from '@angular/core';
import { RouterService } from '@shared/services/router.service';
import { firstValueFrom, take, takeUntil } from 'rxjs';
import { CHAT_PAGE_PATH } from 'src/app/bar/utils/constants';
import { PopupService } from '@local/ui-infra';
import { AppPopupComponent, type AppPopupData } from 'src/app/bar/components/app-popup/app-popup.component';
import { ChatsService } from './chats.service';

@Injectable()
export class ChatsPopupService {
  private readonly ARE_YOU_SURE_POPUP: AppPopupData = {
    showButtons: true,
    content: {
      title: 'Are you sure you want to delete <br> this thread?',
      secondaryButton: 'Cancel',
      primaryButton: 'Delete',
    },
    titleStyle: { 'font-weight': 'normal' },
    messageStyle: { fontSize: '12px' },
  };
  private areYouSurePopupRef;
  private popupService: PopupService = inject(PopupService);
  private chatsService: ChatsService = inject(ChatsService);
  private routerService: RouterService = inject(RouterService);

  deleteSessionPopup(sessionId: string, assistantId: string, redirectEmptyChat: boolean) {
    if (this.areYouSurePopupRef) {
      this.areYouSurePopupRef.destroy();
    }
    this.areYouSurePopupRef = this.popupService.open<AppPopupComponent, AppPopupData>('center', AppPopupComponent, this.ARE_YOU_SURE_POPUP);
    this.areYouSurePopupRef.compInstance.primaryButton.pipe(takeUntil(this.areYouSurePopupRef.destroy$)).subscribe(async () => {
      this.chatsService.deleteSession(sessionId);
      if (redirectEmptyChat) {
        if (assistantId) {
          const assistant = await firstValueFrom(this.chatsService.assistantsForChat$);
          if (assistant[assistantId]) {
            this.routerService.navigateByUrl(`${CHAT_PAGE_PATH}/${assistantId}`);
            return;
          }
        }
        this.routerService.navigateByUrl(CHAT_PAGE_PATH);
      }
    });
    this.areYouSurePopupRef.destroy$.pipe(take(1)).subscribe(() => {
      this.areYouSurePopupRef = null;
    });
  }
}
